import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { computed, flow, observable, runInAction } from "mobx";
import { routeLocationSubscriptionChangePlanPatch } from "@devowl-wp/api-real-commerce";
import { formatNumber, realCommerceRequest, __ } from "../utils";
import { localizePaymentInterval } from "../others";
import { RealCommerceError } from "../exceptions";
let ChangePlan = (_class = class ChangePlan {
  get labelPrice() {
    const {
      labelPaymentInterval,
      data: {
        discount,
        productPlan: {
          price: [{
            currency,
            recurringPrice
          }]
        }
      }
    } = this;
    const priceFormatted = formatNumber(recurringPrice);
    const defaultPrice = `${priceFormatted} ${currency} / ${labelPaymentInterval}`;
    return discount !== null && discount !== void 0 && discount.recurring && discount !== null && discount !== void 0 && discount.absoluteAmountRecurringPrice ? `<s>${defaultPrice}</s> ${formatNumber(discount.discountedRecurringPrice)} ${currency} <font color="#3f8600">(${__("you save %s", discount.relativeAmount % 5 === 0 ? `${discount.relativeAmount} %` : `${formatNumber(discount.absoluteAmountRecurringPrice)} ${currency}`)})</font>` : defaultPrice;
  }
  get labelImmediatePrice() {
    const {
      immediatePrice,
      discount,
      productPlan: {
        price: [{
          currency
        }]
      }
    } = this.data;
    const immediatePriceFormatted = formatNumber(+immediatePrice);
    const defaultPrice = `${immediatePriceFormatted} ${currency}`;
    return discount ? `<s>${defaultPrice}</s> ${formatNumber(discount.discountedImmediatePrice)} ${currency} <font color="#3f8600">(${__("you save %s", discount.relativeAmount % 5 === 0 ? `${discount.relativeAmount} %` : `${formatNumber(discount.absoluteAmountImmediatePrice)} ${currency}`)})</font>` : defaultPrice;
  }
  get labelPaymentInterval() {
    return localizePaymentInterval(this.data.productPlan.paymentInterval);
  }
  constructor(data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    this.store = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.apply = flow(function* () {
      const session = this.store.store;
      this.store.busy = true;
      yield session.probablyRenewJwt();
      try {
        yield realCommerceRequest({
          location: routeLocationSubscriptionChangePlanPatch,
          request: {
            subscription: {
              id: this.store.data.id
            },
            checkout: {
              isPrivacyPolicyAccepted: true,
              isTermsAccepted: true,
              coupon: this.data.discount ? this.store.lastAppliedCoupon || undefined : undefined,
              productPlan: {
                id: this.data.productPlan.id
              }
            }
          },
          settings: {
            headers: session.authorizationHeader
          }
        });
        this.store.lastAppliedCoupon = "";

        // Reload all subscriptions
        session.fetchSubscriptions();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.store.busy = false;
      }
    });
    this.store = store;
    runInAction(() => {
      this.data = data;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "labelPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "labelPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "labelImmediatePrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "labelImmediatePrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "labelPaymentInterval", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "labelPaymentInterval"), _class.prototype)), _class);
export { ChangePlan };